import React, { Suspense } from 'react';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Route, Switch, Redirect } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

/* Ionic CSS — core styles only, variables overridden in global.scss */
import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Custom global styles */
import '@/styles/global.scss';

/* Pages */
import Home from '@/pages/Home';
import About from '@/pages/About';
import Services from '@/pages/Services';
import Work from '@/pages/Work';
import ProjectDetails from '@/pages/ProjectDetails/ProjectDetails';
import Process from '@/pages/Process';
import Contact from '@/pages/Contact';

/* Project Estimator */
import { EstimatorProvider, ProjectEstimator } from '@/components/ProjectEstimator';

setupIonicReact({
  mode: 'md',
  animated: false, // we handle our own animations via Framer Motion
});

const App: React.FC = () => {
  return (
    <IonApp>
      <EstimatorProvider>
        <IonReactRouter>
          <IonRouterOutlet id="main-content" animated={false}>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/about" component={About} />
              <Route exact path="/services" component={Services} />
              <Route exact path="/work" component={Work} />
              <Route exact path="/work/:id" component={ProjectDetails} />
              <Route exact path="/process" component={Process} />
              <Route exact path="/contact" component={Contact} />
              <Redirect to="/" />
            </Switch>
          </IonRouterOutlet>
          <ProjectEstimator />
        </IonReactRouter>
      </EstimatorProvider>
    </IonApp>
  );
};

export default App;
